export const PRIORITY_LEVELS = [
	{ level: 1, text: 'low' },
	{ level: 2, text: 'medium' },
	{ level: 3, text: 'high' },
];
